import React from 'react';
import { formatCNPJ } from '../../utils/masks'; // #314 — CNPJ do tenant mascarado

// Bloco "Emitido por" — identifica a empresa-tenant do Qaa.sa que emite
// o relatório (i.e., a Client do banco do qual o usuário logado faz parte).
// Posicionado abaixo do PrintableHeader, antes da seção 1 Identificação.
//
// Comportamento:
//   - Sem nome (razão social nem fantasia) → bloco não renderiza
//   - Sem logo → bloco renderiza só com texto (sem placeholder)
//   - Sem CNPJ → linha 2 omitida
//   - Sem cidade/UF nem website → linha 3 inteira omitida
//
// Endpoint origem: GET /api/account/profile
// Schema: { razao_social, nome_fantasia, cnpj, website, logo_url,
//           endereco: { cidade, estado, ... }, ... }
export default function EmittedByBlock({ tenant }) {
  if (!tenant) return null;

  const displayName = tenant.razao_social || tenant.nome_fantasia;
  if (!displayName) return null;

  const cidade = tenant.endereco?.cidade;
  const estado = tenant.endereco?.estado;
  const cityState = cidade && estado ? `${cidade}/${estado}` : (cidade || estado || null);

  // Limpa website (remove protocolo para exibição, mantém URL original para o link)
  const websiteRaw = tenant.website ? String(tenant.website).trim() : '';
  const websiteDisplay = websiteRaw
    ? websiteRaw.replace(/^https?:\/\//, '').replace(/\/$/, '')
    : null;
  const websiteUrl = websiteRaw
    ? (websiteRaw.startsWith('http') ? websiteRaw : `https://${websiteRaw}`)
    : null;

  const showLine3 = !!(cityState || websiteDisplay);

  return (
    <section className="emitted-by-block">
      <div className="emitted-by-label">Emitido por</div>
      <div className="emitted-by-card">
        {tenant.logo_url && (
          <img
            src={tenant.logo_url}
            alt={displayName}
            className="emitted-by-logo"
          />
        )}
        <div className="emitted-by-info">
          <div className="emitted-by-name">{displayName}</div>
          {tenant.cnpj && (
            <div className="emitted-by-cnpj">CNPJ: {formatCNPJ(tenant.cnpj)}</div>
          )}
          {showLine3 && (
            <div className="emitted-by-meta">
              {cityState && <span>{cityState}</span>}
              {cityState && websiteDisplay && <span className="separator"> · </span>}
              {websiteDisplay && (
                <a href={websiteUrl} target="_blank" rel="noopener noreferrer">
                  {websiteDisplay}
                </a>
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
